import { gql, request } from "graphql-request"
import { useQuery } from "@tanstack/react-query"
import { useDispatch } from "react-redux"
import { actions } from "src/state/xFer"
import { add, getUnixTime } from "date-fns"
import { BarHistoryResponse } from "src/state/xFer/types"
import { FETCH_BAR_HISTORY } from "src/constants/queryKeys"

const BAR_CLIENT = process.env.REACT_APP_BAR_URL!

export const usePollPastWeekApr = () => {
  const dispatch = useDispatch()

  const { data, isSuccess } = useQuery([FETCH_BAR_HISTORY], fetchBarHistoryData)
  if (isSuccess && data) {
    dispatch(actions.setBarDailySnapshots(data))
  }
}

async function fetchBarHistoryData(): Promise<BarHistoryResponse> {
  const timestamp = getUnixTime(add(new Date(), { days: -7 }))
  try {
    const query = gql`
      query barDailySnapshots($startTime: Int) {
        barDailySnapshots(first: 10, where: { date_gte: $startTime }) {
          date
          ratio
        }
      }
    `
    const data = await request<BarHistoryResponse>(BAR_CLIENT, query, {
      startTime: timestamp,
    })
    return data
  } catch (error) {
    console.error("Failed to query barDailySnapshots", error)
    throw error
  }
}
